// Usually, one screen contains about 2_500 nodes, so 10_000 is more than enough.
export const NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT = 10_000;

// Reasonable value for smart card prefetching.
export const NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH = {
	smartCard: 10,
	emoji: 500,
};
